
export const state = {
    navigationParams: "{}",
    navigatedToPage:""
  };

  export const getters = {
    getNavigationParams(state) {
      return JSON.parse(state.navigationParams);
    },
    getNavigatedToPage(state) {
      return state.navigatedToPage;
    }
  };

  export const mutations = {
    setNavigationParams(state, payload) {
      state.navigationParams = payload;
    },
    setNavigatedToPage(state, payload) {
      state.navigatedToPage = payload;
    },
    deleteNavigationParams(state) {
      state.navigationParams = "{}";
      state.navigatedToPage = "{";
    }
  };

  export const actions = {
    setNavigationParamsAction({ commit }, {params, to}) {
      commit('setNavigationParams', params);
      commit('setNavigatedToPage', to);
    },
    deleteNavigationParamsAction({ commit }) {
      commit('deleteNavigationParams');
    },
  };